import { render, staticRenderFns } from "./CancelMidwife.vue?vue&type=template&id=ed731068"
import script from "./CancelMidwife.vue?vue&type=script&lang=js"
export * from "./CancelMidwife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports